module.exports = __webpack_public_path__ + "media/images/contacts/sara-83cfbbbc17922972e293ef2b2778a3fe.png";